export const login_success = (data) => ({ type: "LOGIN_SUCCESS", data });
export const subadmin_details = (data) => ({ type: "SUBADMIN_DETAILS", data });
export const logout = () => ({ type: "LOG_OUT" });